export default class Tabs {
    constructor(el) {

        this.el = el;
        this.tabs = this.el.querySelector('[data-tabs]');
        this.buttons = this.tabs.querySelectorAll('[data-tab-button]');
        this.targets = Array.from(this.buttons).map((button) => this.el.querySelector(button.dataset.tabButton));


        this.tabs.addEventListener('click', (e) => {
            this.clickedButton = e?.target?.closest('[data-tab-button]');

            if (!this.clickedButton) {
                return;
            }

            this.activateTab(this.clickedButton);
        });
    }

    activateTab(clickedButton) {
        // Activate button
        this.buttons.forEach((button) => {
            if (button === clickedButton) {
                button.classList.add('is-active');
                button.setAttribute('aria-expanded', true);
            } else {
                button.classList.remove('is-active');
                button.setAttribute('aria-expanded', false);
            }
        });

        // Activate content
        this.targets.forEach((target) => {
            if (target.matches(clickedButton.dataset.tabButton)) {
                target.classList.add('is-active');

                if(this.el.getAttribute('data-tab-section') === 'scroll-to-top') {
                    window.scrollTo(0, 0);
                }
            } else {
                target.classList.remove('is-active');
            }
        });
    }
}